export default "__VITE_ASSET__C551b5rD__"